import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { CircleSpinner } from 'react-spinners-kit';

export const StripeSuccessRedirect: React.FC = () => {
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const donationId = searchParams.get('donationId') || '';

  const redirectUrl =
    `${process.env.REACT_APP_APP_URL}/donation-success` +
    (donationId ? `?donationId=${encodeURIComponent(donationId)}` : '');

  useEffect(() => {
    window.location.href = redirectUrl;
  }, [redirectUrl]);

  const containerStyle: React.CSSProperties = {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#ecfdf3', // light green
    padding: '24px',
  };

  const cardStyle: React.CSSProperties = {
    width: '100%',
    maxWidth: '480px',
    backgroundColor: '#ffffff',
    borderRadius: '16px',
    padding: '32px 24px',
    boxShadow: '0 10px 40px rgba(15, 23, 42, 0.12)',
    textAlign: 'center',
  };

  const titleStyle: React.CSSProperties = {
    fontSize: '24px',
    fontWeight: 700,
    color: '#15803d',
    marginBottom: '8px',
  };

  const subtitleStyle: React.CSSProperties = {
    fontSize: '14px',
    color: '#4b5563',
    marginBottom: '24px',
  };

  const buttonStyle: React.CSSProperties = {
    marginTop: '24px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px 18px',
    borderRadius: '9999px',
    backgroundColor: '#16a34a',
    color: '#ffffff',
    fontSize: '14px',
    fontWeight: 600,
    textDecoration: 'none',
  };

  const spinnerWrapperStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '12px',
  };

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <div style={spinnerWrapperStyle}>
          <CircleSpinner size={28} color="#16a34a" />
        </div>
        <h1 style={titleStyle}>Payment Successful</h1>
        <p style={subtitleStyle}>Redirecting you back to the Risen Hope app to finish up your donation.</p>
        <p style={{ fontSize: '12px', color: '#6b7280' }}>
          If nothing happens after a few seconds, tap the button below to return to the app.
        </p>
        <a href={redirectUrl} style={buttonStyle}>
          Click here if you aren&apos;t redirected
        </a>
      </div>
    </div>
  );
};
